<template>
  <div id="followers">
    <b-card overlay :img-src="gif" class="text-center" img-height="350px">
      <span class="card-header text-center">
        <strong>{{ title }}</strong>
      </span>
      <div
        v-if="count < target"
        @mouseover="sendEvent('custom', 'hover', 'custom-gauge-interaction')"
      >
        <br />
        <gauge
          :title="title"
          :current="count"
          :target="target"
          :colour="gaugeColour"
        ></gauge>
      </div>
      <div v-else>
        <br />
        <b-card-img :src="image"></b-card-img>
        <b-list-group flush>
          <b-list-group-item>Achievement Complete!</b-list-group-item>
          <b-list-group-item
            ><strong>Target:</strong> {{ target.toLocaleString() }}
          </b-list-group-item>
          <b-list-group-item
            ><strong>Current:</strong>
            {{ count.toLocaleString() }}
          </b-list-group-item>
        </b-list-group>
      </div>

      <b-list-group flush>
        <div v-if="displaySubButton">
          <b-list-group-item>
            <div :style="style">
              <b-container class="text-center">
                <b-button
                  @click="
                    subscribeToUser();
                    sendEvent('custom', 'click', 'subscribe-user-btn');
                  "
                  >Subscribe to {{ channelName }}</b-button
                >
              </b-container>
            </div>
          </b-list-group-item>
        </div>
        <div v-else></div>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import Gauge from "@/components/utils/Gauge.vue";
import ConfigAPI from "@/api/config.js";
import trophy from "@/assets/trophy.gif";
import { setInterval, setTimeout } from "timers";

export default {
  name: "custom",
  data() {
    return {
      title: "Custom",
      count: 0,
      target: 10,
      image: trophy,

      // images
      gif: "",
      customImg: "",
      trophy: trophy,

      channelName: "",

      displaySubButton: false,
      //theme settings
      ButtonTxtColour: "#FFFFFF",
      ButtonBkgColour: "#5583c7",
      gaugeColour: "#5583c7",
      userFollows: false,
    };
  },
  mounted() {
    this.setConfig();
    this.channelName = ConfigAPI.getUsername();
  },
  activated: function() {
    ga("set", "page", "/custom");
    ga("send", "pageview");
  },
  methods: {
    setConfig: function() {
      var config = ConfigAPI.getBroadcasterConfig();
      if (config.custom) {
        var custom = config.custom;
        if (custom.gauge_colour) {
          this.gaugeColour = custom.gauge_colour;
        }
        if (custom.title) {
          this.title = custom.title;
        }
        if (custom.target) {
          this.target = custom.target;
        }
        if (custom.count) {
          this.count = custom.count;
        }
        if (custom.subButtonEnabled) {
          this.displaySubButton = custom.subButtonEnabled;
        }
      }

      if (config.panel_settings) {
        var panel = config.panel_settings;
        if (panel.font_colour) {
          this.ButtonTxtColour = panel.font_colour;
        }
        if (panel.background_colour) {
          this.ButtonBkgColour = panel.background_colour;
        }
      }

      return;
    },
    newTarget: function(number) {
      this.count += number;

      setTimeout(
        function() {
          this.gif = "";
        }.bind(this),
        120000
      );
    },
    subscribeToUser: function() {
      window.open("https://subs.twitch.tv/" + this.channelName, "_blank");
    },
  },
  computed: {
    style() {
      return {
        "--btnBkgColour": this.ButtonBkgColour,
        "--btnFontColour": this.ButtonTxtColour,
      };
    },
  },
  components: {
    Gauge,
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.card {
  border-color: var(--btnBkgColour);
  border-style: none;
}

.card #followersCard {
  border-style: groove;
}

.card-header {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style>
.popover {
  max-width: none;
}
</style>
